import { toEnvironment, toSite } from './mappers';
const assignmentsPath = (entityId, studyId, environmentId) => `/v1/entities/${entityId}/studies/${studyId}/environments/${environmentId}/environment-site-consent-assignments`;
const normalizeMomListResponse = (payload) => {
    const unwrapped = 'data' in payload ? payload.data : payload;
    return {
        environmentId: unwrapped.environmentId,
        assignments: Array.isArray(unwrapped.assignments) ? unwrapped.assignments : [],
    };
};
export async function getSites(momClient, entityId, studyId) {
    const { data: { data: momSites }, } = await momClient.get(`/v1/entities/${entityId}/studies/${studyId}/sites`);
    return momSites.map(toSite);
}
export async function getEnvironments(momClient, entityId, studyId) {
    const { data: { data: momEnvironments }, } = await momClient.get(`/v1/entities/${entityId}/studies/${studyId}/environments`);
    return momEnvironments.map(toEnvironment);
}
/**
 * Loads site ↔ consent-template assignments for a single environment and expands them to
 * the document-id-oriented shape the UI works with.
 *
 * MOM stores one row per (environmentSiteId, consentTemplateKey). Since the UI deals in
 * document ids (version-specific), every consent file whose `templateKey` matches the
 * backend row is emitted as its own {@link Assignment}. If multiple versions share a key,
 * they will all appear selected — which mirrors the backend's "template rolls forward" model.
 */
export async function getAssignments(momClient, entityId, studyId, environmentId, consentFiles) {
    const { data } = await momClient.get(assignmentsPath(entityId, studyId, environmentId));
    const list = normalizeMomListResponse(data);
    const keyToDocIds = new Map();
    for (const file of consentFiles) {
        const existing = keyToDocIds.get(file.templateKey);
        if (existing) {
            existing.push(file.id);
        }
        else {
            keyToDocIds.set(file.templateKey, [file.id]);
        }
    }
    const expanded = [];
    for (const row of list.assignments) {
        const docIds = keyToDocIds.get(row.consentTemplateKey);
        if (!docIds) {
            continue;
        }
        for (const docId of docIds) {
            expanded.push({
                id: `${row.key}:${docId}`,
                environmentSiteId: row.environmentSiteId,
                consentDocumentId: docId,
            });
        }
    }
    return expanded;
}
